// Admin passkey ceremonies (DESIGN.md "Admin sign-in"): the admin RP only.
import type { AdminSchemas } from "@10twenty/api/admin";
import {
  startAuthentication,
  startRegistration,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/browser";
import { publicApi } from "../api";
import { unwrap } from "../problem";

export { browserSupportsWebAuthn as passkeysSupported } from "@simplewebauthn/browser";

/** Usernameless sign-in with an admin passkey. */
export async function signInWithPasskey(): Promise<AdminSchemas["AdminSession"]> {
  const options = unwrap(await publicApi.POST("/auth/sign-in/options"));
  const credential = await startAuthentication({
    optionsJSON: options.public_key as unknown as PublicKeyCredentialRequestOptionsJSON,
  });
  return unwrap(
    await publicApi.POST("/auth/sign-in", {
      body: { challenge_id: options.challenge_id, credential: credential as unknown as Record<string, unknown> },
    }),
  );
}

/** Checks an enrolment link with the app account's email and password. */
export async function enrolmentOptions(body: AdminSchemas["EnrolmentOptionsRequest"]) {
  return unwrap(await publicApi.POST("/auth/enrolment/options", { body }));
}

/** Creates the first admin passkey for a checked link and signs in. */
export async function enrol(options: AdminSchemas["PasskeyOptions"]): Promise<AdminSchemas["AdminSession"]> {
  const credential = await startRegistration({
    optionsJSON: options.public_key as unknown as PublicKeyCredentialCreationOptionsJSON,
  });
  return unwrap(
    await publicApi.POST("/auth/enrolment", {
      body: { challenge_id: options.challenge_id, credential: credential as unknown as Record<string, unknown> },
    }),
  );
}
